module.exports = __webpack_public_path__ + "media/images/contact_backgroundMobile-55964032.png";